import type { DocumentDownloadPreference } from "referrals/js/enum/document-download-preference";
import { ajaxGet, ajaxPut } from "core/js/spring-ajax";

const USER_DOCUMENT_PREFERENCE_ENDPOINT = "/referrals/rest/document-preferences";

export type JsonUserDocumentPreference = {
  documentDownloadPreference: DocumentDownloadPreference,
};

export async function getUserDocumentPreference(): Promise<JsonUserDocumentPreference> {
  return await ajaxGet<JsonUserDocumentPreference>({
    url: USER_DOCUMENT_PREFERENCE_ENDPOINT,
  });
}

export async function updateUserDocumentPreference(userDocumentPreference: JsonUserDocumentPreference) {
  await ajaxPut<JsonUserDocumentPreference, void>({
    url: USER_DOCUMENT_PREFERENCE_ENDPOINT,
    data: userDocumentPreference,
  });
}
